import ResultList from "./ResultList";
import Separator from "./Separator/Separator";

export default function QuestionResult(props) {
  const { question, numberOfQuestions, showAnswers } = props;
  const { id } = question;

  const questionNumber = id + 1;
  const isCorrect = question.checkAnswer(question.answer);

  return (
    <>
      <ResultList
        question={question}
        answer={question.answer}
        isCorrect={isCorrect}
        questionNumber={questionNumber}
      />
      {showAnswers && !isCorrect && question.answer && (
        <>
          <Separator />
          <ResultList
            question={question}
            answer={question.correctAnswers}
            isCorrect={true}
            questionNumber={questionNumber}
          />
        </>
      )}
      {question.id < numberOfQuestions - 1 && <Separator questionSeparator />}
    </>
  );
}
